import(/* webpackMode: "eager" */ "/app/src/app/ai/policies/page.tsx");
